module.exports = __webpack_public_path__ + "static/media/download.8ee457cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/download.svg
// module id = 60
// module chunks = 0